import { reactive, ref, Ref, onMounted } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { ECOption } from '@/renderer/components/charts/type';
import store from '@/renderer/store';
type Handler = {
  chartLoading: Ref<boolean>;
  chartOptions: ECOption;
  getSpaceStats: () => Promise<void>;
};
export default function userHandler(): Handler {
  const sizeNameList = [
    i18n_t('50M以下'),
    '50M-100M',
    '100M-500M',
    '500M-1G',
    '1G-10G',
    '10G-50G',
    '50G-100G',
    i18n_t('100G以上'),
  ];
  const sizeMap = {
    m50: 50 * 1024 * 1024,
    m100: 100 * 1024 * 1024,
    m500: 500 * 1024 * 1024,
    g1: 1024 * 1024 * 1024,
    g10: 10 * 1024 * 1024 * 1024,
    g50: 50 * 1024 * 1024 * 1024,
    g100: 100 * 1024 * 1024 * 1024,
  };

  // 柱状图配置
  const chartLoading = ref(false);
  const chartOptions: ECOption = reactive({
    grid: {
      containLabel: true,
      top: 10,
      right: 0,
      bottom: 40,
      left: 0,
    },
    legend: {
      bottom: 0,
      data: [
        {
          name: i18n_t('用户人数'),
        },
      ],
    },
    color: ['#014fd1', '#ED7B2F', '#7742B3'],
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: sizeNameList,
      axisTick: {
        show: true,
        alignWithLabel: true,
      },
      splitLine: {
        show: false,
      },
      axisPointer: {
        show: true,
        type: 'shadow',
      },
    },
    yAxis: {
      type: 'value',
      splitNumber: 4,
      axisLabel: {
        inside: false,
      },
      axisLine: {
        show: false,
      },
      // 轴
      splitLine: {
        lineStyle: {
          color: '#E7E7E7',
        },
      },
    },
    tooltip: {
      trigger: 'item',
      show: true,
      enterable: true,
      confine: true,
      position(pos: any[]) {
        return pos;
      },
    },
    series: [],
  });
  const methods = {
    async getSpaceStats() {
      const sizeUserList = [0, 0, 0, 0, 0, 0, 0, 0];
      chartLoading.value = true;
      try {
        const res = await smh.userAPI.getSpaceStats({
          spaceTag: 'personal',
        });
        if (res.data) {
          res.data.forEach(item => {
            const { m50, m100, m500, g1, g10, g50, g100 } = sizeMap;
            const size = +item.size;
            if (size <= m50) {
              sizeUserList[0] += 1;
            } else if (size > m50 && size <= m100) {
              sizeUserList[1] += 1;
            } else if (size > m100 && size <= m500) {
              sizeUserList[2] += 1;
            } else if (size > m500 && size <= g1) {
              sizeUserList[3] += 1;
            } else if (size > g1 && size <= g10) {
              sizeUserList[4] += 1;
            } else if (size > g10 && size <= g50) {
              sizeUserList[5] += 1;
            } else if (size > g50 && size <= g100) {
              sizeUserList[6] += 1;
            } else if (size > g100) {
              sizeUserList[7] += 1;
            }
          });
          chartLoading.value = false;
          Object.assign(chartOptions, {
            series: [
              {
                name: i18n_t('用户人数'),
                data: sizeUserList,
                type: 'bar',
                barWidth: 20,
              },
            ],
          });
        }
      } catch (e: any) {
        chartLoading.value = false;
        tips.error(e);
      }
    },
  };
  store.dispatch('getUserCount');
  return {
    chartLoading,
    chartOptions,
    ...methods,
  };
}
